import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { httpPost} from '../../../app/common/utils/http';


export const fetchNewChat = createAsyncThunk('newChat/fetchNewChat', async (includeWelcome = true, { rejectWithValue }) => {
  try {
    
    let requestData = {
      includeWelcome: includeWelcome
    }
    const data = await httpPost('AVAMessage/GetNewChat', requestData); // Specify endpoint and token requirement
    return data.details;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const newChat = createSlice({
  name: 'newChat',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNewChat.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNewChat.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchNewChat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default newChat.reducer;